import React from "react";

const ShippingPolicyModal = ({ isOpen, onClose, mobile }) => {
  if (!isOpen) return null;

  const sections = [
    {
      title: "1. Digital Nature of Products",
      content:
        "aiComposz provides strictly digital services and products. There are no physical goods, tangible items, or printed materials associated with our service. All outputs generated by our AI models are delivered as digital image files.",
    },
    {
      title: "2. Delivery Method",
      content:
        "We do not offer physical delivery of any kind. All generated digital files are delivered directly within the application interface upon successful completion of the generation process. It is the user's sole responsibility to save or download these files to their own device immediately.",
    },
    {
      title: "3. User Download Responsibility",
      content:
        "As we do not store generated images on our servers (see Absolute User Responsibility in our Terms), the availability of the download is transient. Failure to download the generated files before closing the session or refreshing the page will result in the permanent loss of that content.",
    },
    {
      title: "4. Refund Exclusion for Non-Download",
      content:
        "The failure of a user to download, save, or otherwise capture the generated digital output does not entitle the user to a refund, credit reinstatement, or any form of compensation. By initiating a generation, you acknowledge that the delivery is complete once the image is displayed on your screen.",
    },
  ];

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-2xl md:max-h-[80vh] md:rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-2xl md:max-h-[80vh] rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        // style={{ padding: mobile ? "1rem" : "3rem" }}
      >
        <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <h2 className="text-xl font-bold text-white tracking-tight">Shipping Policy</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="md:h-6 w-6 text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto mt-10 md:p-8 space-y-6 text-sm text-slate-300 leading-relaxed">
          {sections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h3 className="text-indigo-400 font-bold text-base">{section.title}</h3>
              <p>{section.content}</p>
            </div>
          ))}
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyModal;
